import { z } from 'zod/v3';
import { DataObjectRelationVersionSchema } from './DataObjectVersionSchema';
import { zDataObjectType } from './zDataObjectType';

const CalculationSourceItemSchema = z.object({
  data_object_version_id: z.number(),
  version_number: z.number().nullable(),
  minor_number: z.number().nullable(),
  calculation_time: z.string().nullable(),
  status_code: z.string(),
  data_object_description_id: z.number(),
  data_object_group_id: z.number().nullish(),
  data_object_description_code: z.string(),
  data_object_description_name: z.string(),
  data_object_type: zDataObjectType,
  value_date: z.string(),
  calculation_sources: z.string().nullish(),
});

export const CalculationSourcesSchema = z.object({
  sources: z.array(CalculationSourceItemSchema),
  dag: z.record(z.string(), z.array(z.number())),
  conflicts: z.record(z.string(), z.array(z.number())),
  version: z.number(),
});

export const DataObjectRelationsDataConflictsDtoSchema = z.array(
  DataObjectRelationVersionSchema.extend({
    calculationSources: z.preprocess(
      (val) => (typeof val === 'string' ? JSON.parse(val) : val),
      CalculationSourcesSchema,
    ),
  }),
);

export type CalculationSources = z.output<typeof CalculationSourcesSchema>;
export type CalculationSourceItem = CalculationSources['sources'][number];
export type DataObjectRelationsDataConflictsItem = z.output<
  typeof DataObjectRelationsDataConflictsDtoSchema
>[number];
export type DataObjectRelationsDataConflictsDto = z.input<
  typeof DataObjectRelationsDataConflictsDtoSchema
>;
